import React from "react";
import {FiUsers, FiMonitor} from "react-icons/fi";
import {AiOutlineMobile} from "react-icons/ai";
import {HiOutlineUserGroup} from "react-icons/hi";
import {IoBrushOutline} from "react-icons/io5";
import {TbDeviceGamepad2} from "react-icons/tb";
import {useTranslation} from "react-i18next";

const ServiceList = () => {
    const { t } = useTranslation();
    const ServiceListData = [
        {
            icon: <FiUsers/>,
            title: 'MANAGEMENT',
            description: t("services.management")
        },
        {
            icon: <TbDeviceGamepad2/>,
            title: 'GAME DEV',
            description: t("services.gamedev")
        },
        {
            icon: <IoBrushOutline/>,
            title: 'ART',
            description: t("services.art")
        },
        {
            icon: <FiMonitor/>,
            title: 'DEVELOPMENT',
            description: t("services.dev")
        },
        {
            icon: <AiOutlineMobile/>,
            title: 'INFRASTRUCTURE AND SUPPORT',
            description: t("services.support")
        },
        {
            icon: <HiOutlineUserGroup/>,
            title: 'C-LEVEL',
            description: t("services.c-level")
        }
    ]
    const ServiceContent = ServiceListData.slice(0, 6);

        return (
            <React.Fragment>
                <div className="row">
                    {ServiceContent.map((val, i) => (
                        <div className={`col-lg-4 col-md-6 col-sm-6 col-12 text-center`} key={i}>
                            <a href="#contact">
                                <div className="service service__style--2">
                                    <div className="icon">
                                        {val.icon}
                                    </div>
                                    <div className="content">
                                        <h3 className="title">{val.title}</h3>
                                        <p>{val.description.split('\n').map(str => <p className="services-description-list">{str}</p>)}</p>
                                    </div>
                                </div>
                            </a>
                        </div>
                    ))}
                </div>
            </React.Fragment>
        )
}

export default ServiceList;
